import { render, staticRenderFns } from "./space-form.vue?vue&type=template&id=65ef9f70&scoped=true"
import script from "./space-form.vue?vue&type=script&lang=js"
export * from "./space-form.vue?vue&type=script&lang=js"
import style0 from "./space-form.vue?vue&type=style&index=0&id=65ef9f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ef9f70",
  null
  
)

export default component.exports